import LogisticsTrack from "./LogisticsTrack";

export default LogisticsTrack;
